import { Component, Input } from '@angular/core';
import { MemberDto } from '../../../../../service/dto';

@Component({
  selector: 'app-member-view-claims',
  standalone: false,
  templateUrl: './member-view-claims.component.html',
  styleUrl: './member-view-claims.component.scss'
})
export class MemberViewClaimsComponent {
	@Input() member!: MemberDto;
}
